"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { makeDataField } from '../index.mjs';
import { ValueMapping } from '../Nested/ValueMapping.mjs';
import useDataBuilderField from '../use-data-builder-field.mjs';
import { useFormComponents } from '../use-form-components.mjs';

const MapFormula = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "formula", ref, onClick: props.onClick, onDelete: props.onDelete, children: [
    /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Function }),
    " Map values"
  ] });
});
MapFormula.displayName = "MapFormula";
function MapFormulaDropdown({
  formula,
  onChange,
  variablesSchema
}) {
  const { DataBuilderForm } = useFormComponents();
  const { field } = useDataBuilderField();
  const mappingField = {
    ...field,
    value: { $map: formula.args ?? {} }
  };
  function handleValueChange(value) {
    onChange?.({
      $map: {
        ...formula.args ?? {},
        value
      }
    });
  }
  function handleMappingChange(value) {
    onChange?.({
      $map: {
        ...formula.args ?? {},
        mapping: value
      }
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DataBuilderForm,
      {
        field: makeDataField({
          schema: { type: "string", title: "Source Value" },
          value: formula.args?.value,
          variablesSchema
        }),
        onChange: handleValueChange
      }
    ),
    /* @__PURE__ */ jsx(ValueMapping, { field: mappingField, onChange: handleMappingChange })
  ] });
}

export { MapFormulaDropdown, MapFormula as default };
